import userCenter from '@/constants/userCenter';
import errorCode from '@/constants/errorCode';
import { handleWindow } from '@/utils/common';

const handleToUserCenter = (code: number, backUrl = handleWindow().location.href) => {
  const {
    login,
    bindPhone
  } = userCenter(backUrl);
  if (code === errorCode.UNAUTHORIZED) {
    return login;
  } else if (code === errorCode.UNBIND_PHONE) {
    return bindPhone;
  }

  return login;

}

export default handleToUserCenter;
